<template>
  <div id='index'>
    <router-view></router-view>
    <div v-show="$route.meta.keepAlive">
      <div class="content-title">
        <Icon type="android-settings"></Icon>客戶資料簿
        <div class="border"></div>
      </div>
      <p style="font-size:16px;margin:10px 0px">客戶總數: {{count}}</p> 
      <Table border :columns="column" :data="data"></Table>
    </div>
  </div>
</template>

<script>
import { API } from "@/assets/config";
import errorHandle from "@/assets/errorHandle"
export default {
  name: "teamList",
  data() {
    return {
      column: [
        { title: '車隊名稱', key: 'name' },
        { title: '聯絡人', key: 'manager_name' },
        { title: '聯絡電話', key: 'phone' },
        { 
          title: '檢視', 
          key: 'review',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    console.log(params)
                    this.show(params.index)
                  }
                }
              }, '檢視')
            ]);
          } 
        }
      ],
      data: [],
      count: 0
    };
  },
  created() {
    this.getTeamList()
  },    
  watch:{
    $route (to, from){
      if(to.name === "teamList")
        this.getTeamList()
    }
  },
  methods: {
    async getTeamList() {
      try {
        let res = await this.axios.get(API.teams)
        console.log(res)
        this.data = res.data.teamList
        this.count = res.data.count
      } catch (error) {
        this.errorHandle(error)
      }
    },
    show (tableIndex) {
      let id = this.data[tableIndex].id
      this.$router.push({name: 'teamEdit', params: { id}})
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/team/teamList.vue